import { Stack, Typography } from "@material-ui/core";
import { Box } from "@material-ui/system";
import stakeshotBG from "src/assets/images/stakeshotBG.svg";
import { CustomButton } from "../components/CustomButton";
import { PoSProjects } from "../components/PoSProjects";
import { StakeshotDescription } from "../components/StakeshotDescription"

export const Stakeshot = () => {
    return (
        <Box minHeight="calc(100vh - 370px);">
            <Box style={{
                width: "100%",
                background: "#FFFFFF",

            }} display="flex" flexDirection="column" alignItems="center">
                <Box p="50px 95px 49px" width="1280px" position="relative">
                    <img src={stakeshotBG} style={{
                        top: "110px",
                        right: "100px",
                        position: 'absolute',
                        width: "180px",
                        height: "154px"
                    }} />
                    <Box>
                        <Typography
                            fontSize="30px"
                            variant="bold"
                            color="#0E1011"
                            lineHeight="30px"
                        >
                            An opensource snapshot
                        </Typography>
                    </Box>
                    <Box>
                        <Typography
                            fontSize="30px"
                            variant="bold"
                            color="#0E1011"
                            lineHeight="30px"
                        >
                            tool of staker
                        </Typography>
                    </Box>
                    <Typography fontSize="16px" lineHeight="16px" color="#848484" mt="20px">
                        Airdrop tool and service for Web3
                    </Typography>

                    <Box mt="40px">
                        <input placeholder="TOKEN NAME" disabled className="stakeshot_input" />
                    </Box>
                    <Box mt="40px">


                        <CustomButton
                            // disabled={!poolItem.opened}
                            fontSize="18px"
                            padding="17px 62px"
                            color="darkButtonBg"
                            onClick={() => {
                            }}
                        >
                            Soon
                        </CustomButton>
                    </Box>
                </Box>
            </Box>

            <Box display="flex" flexDirection="column" alignItems="center">
                <Box width="1280px" id="pools">

                    {
                        <PoSProjects />
                    }
                </Box>
            </Box>
            <Stack
                alignSelf="stretch"
                alignItems="center"
                sx={{
                    backgroundColor: "#1D232A",
                }}
            >
                <Box width="1280px" p="100px 110px 122px" position="relative">
                    <StakeshotDescription />
                </Box>
            </Stack>
        </Box>
    );
};